/*jshint esversion: 11 */
import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input
} from 'reactstrap';
import Select from 'react-select';

import { getTagList } from '../../api/tag';
import { getBatchList } from '../../api/batch';

const FilterCircularModal = ({
  modalOpenState,
  closeModalHandler,
  applyFilters,
  resetFilters,
  selectedTag,
  setSelectedTag,
  selectedBatches,
  setSelectedBatches,
  isDeleted,
  setIsDeleted,
  authUser
}) => {
  const [tagOptions, setTagOptions] = useState([]);
  const [tagOptionsLoading, setTagOptionsLoading] = useState(false);
  const [batchOptions, setBatchOptions] = useState([]);
  const [batchOptionsLoading, setBatchOptionsLoading] = useState(false);

  const buildOptions = (list) =>
    list.map((item) => ({
      value: item._id,
      label: item.name
    }));

  async function fetchBatchOptions() {
    try {
      setBatchOptionsLoading(true);
      const response = await getBatchList(1, 1000, {}, 'name$asc');
      if (response) {
        const options = response.data.map((batch) => ({
          value: batch._id,
          label: batch.name,
          startDate: new Date(batch.start_date),
          endDate: new Date(batch.end_date)
        }));
        setBatchOptions(options);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setBatchOptionsLoading(false);
    }
  }

  const fetchTagOptions = async () => {
    setTagOptionsLoading(true);
    const response = await getTagList(1, 100);
    if (response) {
      setTagOptions(buildOptions(response?.data || []));
      setTagOptionsLoading(false);
    }
  };

  useEffect(() => {
    fetchTagOptions();
    fetchBatchOptions();
  }, []);

  return (
    <Modal isOpen={modalOpenState} backdrop="static">
      <ModalHeader toggle={closeModalHandler}>Filter Circulars</ModalHeader>

      <ModalBody>
        <FormGroup>
          <Label>Tag</Label>
          <Select
            options={tagOptions}
            value={selectedTag}
            onChange={setSelectedTag}
            disabled={tagOptionsLoading}
            isLoading={tagOptionsLoading}
            isClearable
          />
        </FormGroup>

        <FormGroup>
          <Label>Batches</Label>
          <Select
            options={batchOptions}
            value={selectedBatches}
            onChange={setSelectedBatches}
            disabled={batchOptionsLoading}
            isLoading={batchOptionsLoading}
            isMulti
          />
        </FormGroup>

        {authUser && authUser.user_type === 'super_admin' && (
          <FormGroup>
            <Label>Is Deleted</Label>
            <div className="custom-control custom-switch mb-2" dir="ltr">
              <Input
                id="customSwitch"
                name="isComplted"
                type="checkbox"
                className="custom-control-input p-3"
                defaultChecked={isDeleted}
              />
              <Label
                htmlFor="customSwitch"
                className="custom-control-label"
                onClick={() => setIsDeleted(!isDeleted)}
              >
                Deleted Circulars
              </Label>
            </div>
          </FormGroup>
        )}
      </ModalBody>

      <ModalFooter>
        <Button
          size="sm"
          type="submit"
          color="primary"
          onClick={() => applyFilters()}
        >
          Apply Filter
        </Button>
        <Button
          size="sm"
          type="button"
          color="success"
          onClick={() => resetFilters()}
        >
          Reset
        </Button>
        <Button
          size="sm"
          type="button"
          color="light"
          onClick={closeModalHandler}
        >
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default FilterCircularModal;
